import React from 'react';
import c from 'classnames';
import { ArticleFrontMatter, BlogProps } from '../index';
import { MdStringRenderer } from '../../../../md-string-renderer';
import { WithImageControls } from '../../../../with-image-controls';
import dateFormat from 'dateformat';
export interface ArticleSummaryProps extends BlogProps {
   article: ArticleFrontMatter;
   fullscreenApi;
}

export const ArticleSummary = (props: ArticleSummaryProps) => {
   const { image, title, summary, tags, pagePath, publishDate } = props.article;
   const displayDate = dateFormat(new Date(publishDate), 'yyyy-mm-dd');
   const { showPublishedDate, showMoreBtnText, fullscreenApi } = props;

   let tagsToShow = tags;
   if (tagsToShow && tagsToShow.length === 1 && tagsToShow[0] === '') {
      tagsToShow = null;
   }

   return (
      <div className="group h-full flex flex-col overflow-hidden items-center justify-center bg-primary-light text-primary-light shadow-md">
         <div className="relative h-2/5 flex-shrink-0 w-full overflow-hidden md:self-stretch">
            <WithImageControls
               className="h-full w-full object-cover transition-all transform duration-500 ease-in-out group-hover:scale-105"
               {...{ ...props, image, fullscreenApi }}
            />
         </div>
         <div className={c('flex flex-grow flex-col my-5 p-5')}>
            <div className="my-5 font-bold text-3xl">
               <MdStringRenderer source={title} />
            </div>
            {showPublishedDate ? (
               <div className="text-sm font-extralight my-1">
                  <MdStringRenderer source={displayDate} />
               </div>
            ) : null}

            <div className="flex flex-wrap text-sm font-semibold my-1">
               {tagsToShow?.map((item: string) => (
                  <div key={item} className="flex p-2 m-1 bg-secondary text-secondary">
                     <MdStringRenderer className="no-underline" source={item} />
                  </div>
               ))}
            </div>
            <div className="flex-1 my-2 text-justify">
               <MdStringRenderer source={summary} />
            </div>
            <div className="my-2 flex justify-end underline">
               <MdStringRenderer className="hover:text-primary-dark" source={`[${showMoreBtnText}](${pagePath})`} />
            </div>
         </div>
      </div>
   );
};
export default ArticleSummary;
